import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import ArticleDate from '../../components/article/article-date';
import ArticleExcerpt from '../../components/article/article-excerpt';
import ArticleHeader from '../../components/article/article-header';
import ArticleSources from '../../components/article/article-sources';
import ArticleTitle from '../../components/article/article-title';
import Calculator from '../../components/calculators/calculator';
import CalculatorArticleContent from '../../components/calculators/calculator-article-content';
import CalculatorArticleFooter from '../../components/calculators/calculator-article-footer';
import CalculatorArticleSidebar from '../../components/calculators/calculator-article-sidebar';
import Framework from '../../components/framework';
import Breadcrumb from '../../components/framework/breadcrumb';
import Trans from '../../components/translation/trans';
import useTranslation from '../../hooks/use_translation';

const CalculatorTestosterone = ({ location }) => {
	const { t } = useTranslation('calculator_progesterone_estradiolratio');
	const published_at = '2024-04-05T11:33:00.000Z';
	const sources = [
		{
			authors: 'Elgindy EA',
			date: '2011-02-16',
			publication: '',
			title:
				'Progesterone level and progesterone/estradiol ratio on the day of hCG administration: detrimental cutoff levels and new treatment strategy',
			url: 'https://academic.oup.com/jcem/article/84/10/3666/2660660',
		},
	];

	return (
		<Framework
			description={t('meta_description')}
			location={location}
			tags={t('meta_keywords')}
			title={t('title')}
			tracking={{ content_group: 'Calculator' }}
		>
			<section id="content">
				<div className="container px-0 mt-lg-3 mt-2">
					<nav aria-label="breadcrumb">
						<Breadcrumb
							calculator
							className=""
							fact={true}
							links={[{ active: true, title: t('t1') }]}
						/>
					</nav>
				</div>
			</section>

			<div className="container article calculator-article" id="article">
				<div className="grid">
					<div className="grid-intro">
						<ArticleHeader>
							<ArticleTitle>{t('t1')}</ArticleTitle>
							<ArticleDate published_at={published_at} />
							{sources && <ArticleSources sources={sources} />}
						</ArticleHeader>
						<ArticleExcerpt>
							<Trans i18nKey="t2" t={t} />
						</ArticleExcerpt>
					</div>
					<CalculatorArticleSidebar>
						<Calculator model="progesterone_estradiol_ratio" />
					</CalculatorArticleSidebar>
					<div className="grid-content">
						<CalculatorArticleContent>
							<Trans i18nKey="t3" t={t} />
						</CalculatorArticleContent>
						<CalculatorArticleFooter
							include_articles={
								process.env.NODE_ENV == 'development' ? [3] : [279, 34]
							}
							include_products={
								process.env.NODE_ENV == 'development' ? [1] : [84, 125, 126]
							}
						/>
					</div>
				</div>
			</div>
		</Framework>
	);
};

CalculatorTestosterone.propTypes = {
	location: PropTypes.object.isRequired,
};

export default CalculatorTestosterone;

export const query = graphql`
	query {
		locales: allLocale {
			...translationFields
		}
	}
`;
